<template>
  <div class="operation-report-list-page-layout">
    <!-- vx-card表示領域 -->
    <div
      class="vx-card operation-report-list-page-layout-card vs-con-loading__container"
    >
      <!-- 一覧タブ切替え領域 -->
      <!-- タブのヘッダー -->
      <div class="card-top-tab-area flex items-center">
        <ul class="tabs">
          <template>
            <li
              v-for="tab in tabInfo"
              :key="tab.id"
              :class="{ active: tab.id === activeTab }"
              class="flex justify-center items-center"
              @click="onClickTab(tab.id)"
            >
              <img :src="getIconFromIconMap(tab.icon)" />
              <span
                class="ml-2 whitespace-no-wrap aisea-text-16-400-dark-gray"
                >{{ tab.title }}</span
              >
            </li>
          </template>
        </ul>
      </div>
      <!-- タブでない、実際のヘッダー部分 -->
      <div
        class="p-6 pt-2 h-full uk-position-relative operation-report-list-page-layout-tab-area"
      >
        <template>
          <div class="w-full h-full">
            <operation-report-table
              :aoEnterpriseId="activeTab"
              :initialSearchConditions="initialSearchConditions"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import OperationReportTable from "../OperationReportTable";

import has from "lodash/has";

import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("operations");
const ALL = "ALL"; // 全てのレポート選択時

export default {
  name: "OperationReportListPageLayout",
  components: {
    OperationReportTable,
  },
  props: {
    initialSearchConditions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTab: ALL,

      iconMap: {
        [ALL]: require(`@/assets/images/icons/operation/description.svg`),
        article_outlined: require(`@/assets/images/icons/operation/article_outlined.svg`),
        assignment_outlined: require(`@/assets/images/icons/operation/assignment_outlined.svg`),
        assignment_turned_in_outlined: require(`@/assets/images/icons/operation/assignment_turned_in_outlined.svg`),
        badge_outlined: require(`@/assets/images/icons/operation/badge_outlined.svg`),
        content_paste_outlined: require(`@/assets/images/icons/operation/content_paste_outlined.svg`),
        description_outlined: require(`@/assets/images/icons/operation/description_outlined.svg`),
        directions_boat_outlined: require(`@/assets/images/icons/operation/directions_boat_outlined.svg`),
        edit_calendar_outlined: require(`@/assets/images/icons/operation/edit_calendar_outlined.svg`),
        edit_location_alt_outlined: require(`@/assets/images/icons/operation/edit_location_alt_outlined.svg`),
        ev_station_outlined: require(`@/assets/images/icons/operation/ev_station_outlined.svg`),
        event_note_outlined: require(`@/assets/images/icons/operation/event_note_outlined.svg`),
        fact_check_outlined: require(`@/assets/images/icons/operation/fact_check_outlined.svg`),
        feedback_outlined: require(`@/assets/images/icons/operation/feedback_outlined.svg`),
        gas_meter_outlined: require(`@/assets/images/icons/operation/gas_meter_outlined.svg`),
        info_outline: require(`@/assets/images/icons/operation/info_outlined.svg`),
        inventory_outlined: require(`@/assets/images/icons/operation/inventory_outlined.svg`),
        list_alt_outlined: require(`@/assets/images/icons/operation/list_alt_outlined.svg`),
        local_gas_station_outlined: require(`@/assets/images/icons/operation/local_gas_station_outlined.svg`),
        note_alt_outlined: require(`@/assets/images/icons/operation/note_alt_outlined.svg`),
        notification_important_outlined: require(`@/assets/images/icons/operation/notification_important_outlined.svg`),
        notifications_active_outlined: require(`@/assets/images/icons/operation/notifications_active_outlined.svg`),
        precision_manufacturing_outlined: require(`@/assets/images/icons/operation/precision_manufacturing_outlined.svg`),
        sticky_note_2_outlined: require(`@/assets/images/icons/operation/sticky_note_2_outlined.svg`),
        task_outlined: require(`@/assets/images/icons/operation/task_outlined.svg`),
      },
    };
  },
  computed: {
    ...mapGetters(["sortedValidOperations"]),
    // タブで切り替え可能な画面の情報
    tabInfo() {
      if (!Array.isArray(this.sortedValidOperations)) return [];
      return this.sortedValidOperations.reduce(
        (acc, operation) => {
          const { id, icon, name } = operation;
          acc.push({
            id: id,
            title: name,
            icon: icon,
          });
          return acc;
        },
        [
          {
            id: ALL,
            title: this.$t("Views.Operation.Report.All"),
            icon: ALL,
          },
        ]
      );
    },
  },

  methods: {
    getIconFromIconMap(key) {
      // this.iconMapにkeyのキーがあるかどうか確認する
      if (has(this.iconMap, key)) {
        return this.iconMap[key];
      } else {
        null;
      }
    },

    onClickTab(tabId) {
      this.activeTab = tabId;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.operation-report-list-page-layout {
  font-family: $aisea-font-family;
  color: $aisea-black;

  ::v-deep .tabs {
    list-style-type: none;
    padding: 0;
    display: flex;

    overflow-x: scroll;

    /*スクロールバー非表示（IE・Edge）*/
    -ms-overflow-style: none;
    /*スクロールバー非表示（Firefox）*/
    scrollbar-width: none;
  }

  ::v-deep .tabs li {
    padding: 10px 20px;
    cursor: pointer;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    transition: background-color 0.2s ease-in-out;
    font-size: 16px;
  }
  ::v-deep .tabs li:hover:not(.active) {
    background-color: #e1e1e1;
  }

  ::v-deep .tabs li.active {
    cursor: default;
    border-bottom: none;
    border-top: $aisea-blue solid 3px;
    span {
      font-weight: bold;
    }
  }

  .operation-report-list-page-layout-card {
    margin-top: 1rem;
  }
}
</style>
